/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable jsx-a11y/accessible-emoji */
import { useAmplitude } from "lib/amplitude/Amplitude";
import * as React from "react";
import * as palette from "../palette";

interface INomadCashbackAdProps {
  onClose: () => void;
}

export default function NomadCashbackAd({ onClose }: INomadCashbackAdProps) {
  const amplitude = useAmplitude();

  return (
    <div
      css={{
        position: "relative",
        display: "grid",
        gridColumnGap: 30,
        gridTemplateColumns: "repeat(12, 1fr)",
        alignItems: "center",
        boxSizing: "border-box",
        width: "100%",
        padding: 32,
        backgroundImage: `linear-gradient(to left, #ffd500f9, #030203)`,
        borderRadius: 6,
        borderTopRightRadius: 0,
        boxShadow: "0 1px 3px 0 #33333333",
      }}
    >
      <div
        css={{
          gridColumn: "span 2",
          textAlign: "center",
        }}
      >
        <Nomad />
      </div>

      <div
        css={{
          gridColumn: "span 8",
          "& > p": {
            margin: 0,
            color: palette.white,
            fontWeight: 500,
            fontSize: 16,
            lineHeight: 1.33,
            letterSpacing: 1,
            marginLeft: 16,
            "& > strong:last-of-type": {
              textDecoration: "underline",
            },
          },
        }}
      >
        <p>
          Aproveite a parceria que fizemos com a Nomad e tenha{" "}
          <strong>
            até U$20 de cashback após feita a 1ª remessa de pelo menos $100 em até 15 dias da abertura da conta
          </strong>
          .
        </p>

        <p style={{ marginTop: 12 }}>
          Clique no link ao lado, e aplique o cupom <strong>FUNDAMENTEI20</strong>. Faça sua remessa e aguarde para que
          o benefício seja creditado direto na sua conta.
        </p>
      </div>

      <div
        css={{
          gridColumn: "span 2",
          textAlign: "center",
        }}
      >
        <a
          href="https://nomad.onelink.me/wIQT/fundamentei"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            amplitude.logEvent("Click on Nomad Download app button");
          }}
          css={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: 72,
            color: palette.white,
            fontWeight: "bold",
            fontSize: 16,
            lineHeight: 1.33,
            letterSpacing: 1.13,
            textDecoration: "none",
            backgroundColor: "#000000",
            borderRadius: 12,
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          Baixar o app
        </a>
      </div>

      <div
        css={{
          position: "absolute",
          top: 0,
          right: 0,
          marginTop: -12,
          marginRight: -12,
        }}
      >
        <button
          type="button"
          aria-label="Fechar"
          onClick={() => {
            onClose();
            amplitude.logEvent("Closed Nomad banner");
          }}
          css={{
            display: "flex",
            boxSizing: "border-box",
            margin: 0,
            padding: 0,
            background: "transparent",
            border: "none",
            cursor: "pointer",
          }}
        >
          <TimesIcon width={24} height={24} />
        </button>
      </div>
    </div>
  );
}

function TimesIcon(props: React.SVGProps<any>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 28 28" {...props}>
      <g fill="none">
        <path
          fill="#A53131"
          d="M14 0C6.266 0 0 6.266 0 14s6.266 14 14 14 14-6.266 14-14S21.734 0 14 0zm6.865 17.675a.677.677 0 010 .96l-2.236 2.23a.677.677 0 01-.96 0L14 17.16l-3.675 3.704a.677.677 0 01-.96 0l-2.23-2.236a.677.677 0 010-.96L10.84 14l-3.704-3.675a.677.677 0 010-.96L9.371 7.13a.677.677 0 01.96 0L14 10.839l3.675-3.704a.677.677 0 01.96 0l2.235 2.236a.677.677 0 010 .96L17.161 14l3.704 3.675z"
        />
        <path
          fill="#FFF"
          d="M20.865 17.675a.677.677 0 010 .96l-2.236 2.23a.677.677 0 01-.96 0L14 17.16l-3.675 3.704a.677.677 0 01-.96 0l-2.23-2.236a.677.677 0 010-.96L10.84 14l-3.704-3.675a.677.677 0 010-.96L9.371 7.13a.677.677 0 01.96 0L14 10.839l3.675-3.704a.677.677 0 01.96 0l2.235 2.236a.677.677 0 010 .96L17.161 14l3.704 3.675z"
        />
      </g>
    </svg>
  );
}

function Nomad(props: React.SVGProps<any>) {
  return (
    <svg width={179} height={40} {...props}>
      <g fill="#FFD400">
        <path d="M47.344 20.698v-.076c0-7.949 6.166-14.628 14.843-14.628 8.703 0 14.767 6.577 14.767 14.527v.076c0 7.949-6.166 14.628-14.843 14.628s-14.767-6.577-14.767-14.527zm24.408 0v-.076c0-5.485-4.009-10.057-9.641-10.057-5.633 0-9.54 4.495-9.54 9.981v.076c0 5.486 4.009 10.007 9.641 10.007 5.608 0 9.54-4.445 9.54-9.93zM84.21 8.813a2.503 2.503 0 012.512-2.515h.533c1.09 0 1.826.56 2.308 1.321l8.576 13.41 8.627-13.46c.533-.839 1.268-1.296 2.258-1.296h.533a2.487 2.487 0 012.511 2.514v23.67c0 1.372-1.09 2.464-2.511 2.464a2.481 2.481 0 01-2.461-2.464v-16.94l-6.927 10.388c-.533.812-1.167 1.295-2.106 1.295-.888 0-1.522-.483-2.055-1.295l-6.876-10.311v16.914c0 1.371-1.09 2.413-2.461 2.413-1.37 0-2.436-1.042-2.436-2.413L84.21 8.813zm34.912 22.704l10.53-23.44c.557-1.245 1.572-2.007 2.993-2.007h.229c1.42 0 2.385.762 2.968 2.006l10.53 23.416c.202.356.279.737.279 1.041 0 1.321-1.015 2.388-2.335 2.388-1.167 0-1.979-.686-2.435-1.727l-2.31-5.283h-13.75l-2.386 5.46c-.406 1.016-1.268 1.575-2.309 1.575a2.286 2.286 0 01-2.309-2.311c0-.356.102-.711.305-1.118zm18.547-8l-4.973-11.428-4.973 11.428h9.946zM153.4 8.965c0-1.422 1.09-2.514 2.511-2.514h8.043C172.86 6.45 179 12.546 179 20.495v.076c0 7.95-6.165 14.146-15.046 14.146h-8.043c-1.42 0-2.511-1.092-2.511-2.514V8.965zm10.58 21.257c5.962 0 9.844-3.987 9.844-9.524v-.076c0-5.536-3.882-9.625-9.844-9.625h-5.582v19.225h5.582zM0 5.638a2.503 2.503 0 012.512-2.514h.533c1.218 0 1.826.66 2.664 1.346l29.507 24.533V5.562c0-1.32 1.091-2.438 2.436-2.438a2.443 2.443 0 012.461 2.438V33.93c0 1.372-1.065 2.464-2.435 2.464h-.203c-1.168 0-1.776-.635-2.665-1.321L4.897 10.184v23.772c0 1.32-1.091 2.412-2.436 2.412-1.37 0-2.461-1.092-2.461-2.412V5.638z" />
        <path d="M14.208 20.597c-1.37 0-2.46 1.092-2.46 2.413v14.577c0 1.32 1.09 2.413 2.46 2.413 1.345 0 2.436-1.092 2.436-2.413V23.035a2.438 2.438 0 00-2.436-2.438zm11.722 9.727c-1.37 0-2.46 1.092-2.46 2.413v4.85c0 1.32 1.09 2.413 2.46 2.413 1.345 0 2.436-1.092 2.436-2.413v-4.85c0-1.321-1.091-2.413-2.436-2.413zM25.93 0c-1.37 0-2.46 1.092-2.46 2.413v13.79c0 1.32 1.09 2.413 2.46 2.413 1.345 0 2.436-1.092 2.436-2.413V2.438A2.438 2.438 0 0025.93 0zM14.208 0c-1.37 0-2.46 1.092-2.46 2.413V6.45c0 1.32 1.09 2.412 2.46 2.412 1.345 0 2.436-1.092 2.436-2.412V2.438A2.438 2.438 0 0014.208 0z" />
      </g>
    </svg>
  );
}
